import React from 'react';
import Button from 'design-system/src/components/Button/Button';
import { Typography } from 'design-system/src/components/Typography/Typography';
import { createTrackingProps } from 'shared-utils/analytics';
import gradientEhrIcon from 'design-system/src/assets/icons/gradientEhr.png';
import { Ehr } from '../../types';
import { getEhrDisplayName } from '../../utils';

export type EhrUpsellCardProps = {
  /**
   * Class name for additional styling; used to pass down styles when using inheritance in styled components
   */
  className?: string;
  /**
   * The EHR value to display in the card
   */
  ehr: Ehr;
  /**
   * Callback function called when the Connect button is clicked
   */
  onConnect: () => void;
  /**
   * Callback function called when the Dismiss button is clicked
   */
  onDismiss: () => void;
};

/**
 * Card component that displays an upsell message for connecting an EHR system.
 */
export const EhrUpsellCard = ({ className, ehr, onConnect, onDismiss }: EhrUpsellCardProps) => {
  return (
    <div className={className}>
      <div className="flex w-full justify-center">
        <div
          className={`
            flex w-[224px] flex-col gap-4 rounded-md border
            border-grayscale-100
            bg-surface-200
            px-3 pb-2 pt-3
          `}
        >
          <img
            src={gradientEhrIcon}
            alt=""
            aria-hidden={true}
            className={`mx-auto h-[66px] w-[62px] rounded-md object-cover`}
          />

          <div className="flex flex-col gap-2">
            <Typography styledAs="bodySmallDMSans" weight={600}>
              {`Connect ${getEhrDisplayName(ehr)}`}
            </Typography>
            <Typography styledAs="bodyExtraSmallDMSans" color="var(--grayscale-600)">
              Connecting with your Electronic Health Record allows Tandem to automatically attach lab notes with your
              prescriptions.
            </Typography>
          </div>

          <div className="flex w-full flex-col gap-1">
            <Button
              size="sm"
              onClick={onConnect}
              className="!w-full"
              {...createTrackingProps({ elementName: 'Sidebar: EHR Upsell Card Connect Button', unmask: true })}
            >
              Connect
            </Button>
            <Button
              size="sm"
              variant="tertiary"
              onClick={onDismiss}
              className={`
                !w-full !border-transparent !bg-transparent
                !text-purple-700
                hover:!text-purple-900
              `}
              {...createTrackingProps({ elementName: 'Sidebar: EHR Upsell Card Dismiss Button', unmask: true })}
            >
              Dismiss
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EhrUpsellCard;
